import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import * as URL from "../../helpers/url_helper";

const api = new APIClient();

export const fetchSequences = createAsyncThunk("sequences/list",
  async () => api.get(URL.GET_SEQUENCES));

export const createSequence = createAsyncThunk("sequences/create",
  async (body) => api.create(URL.ADD_SEQUENCE, body));

export const updateSequence = createAsyncThunk("sequences/update",
  async ({ id, body }) => api.put(`${URL.UPDATE_SEQUENCE}/${id}`, body));

export const deleteSequence = createAsyncThunk("sequences/delete",
  async (id) => { await api.delete(`${URL.DELETE_SEQUENCE}/${id}`); return id; });

export const enrollLead = createAsyncThunk("sequences/enroll",
  async ({ sequenceId, leadId }) =>
    api.create(`${URL.ENROLL_SEQUENCE}/${sequenceId}/enroll`, { leadId }));

export const unenroll = createAsyncThunk("sequences/unenroll",
  async (enrollmentId) => {
    await api.delete(`${URL.UNENROLL_SEQUENCE}/${enrollmentId}`);
    return enrollmentId;
  });

export const fetchLeadEnrollments = createAsyncThunk("sequences/leadEnrollments",
  async (leadId) => {
    const data = await api.get(`${URL.GET_LEAD_ENROLLMENTS}/${leadId}/enrollments`);
    return { leadId, enrollments: data };
  });

const slice = createSlice({
  name: "sequences",
  initialState: {
    items: [],
    loading: false,
    saving: false,
    error: null,
    enrollmentsByLead: {},
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchSequences.pending,   (s) => { s.loading = true; s.error = null; });
    b.addCase(fetchSequences.fulfilled, (s, a) => { s.loading = false; s.items = a.payload || []; });
    b.addCase(fetchSequences.rejected,  (s, a) => { s.loading = false; s.error = a.error.message; });

    b.addCase(createSequence.pending,  (s) => { s.saving = true; });
    b.addCase(createSequence.fulfilled, (s, a) => { s.saving = false; s.items.unshift(a.payload); });
    b.addCase(createSequence.rejected, (s, a) => { s.saving = false; s.error = a.error.message; });

    b.addCase(updateSequence.fulfilled, (s, a) => {
      const i = s.items.findIndex(x => x.id === a.payload.id);
      if (i >= 0) s.items[i] = a.payload;
    });

    b.addCase(deleteSequence.fulfilled, (s, a) => {
      s.items = s.items.filter(x => x.id !== a.payload);
    });

    b.addCase(fetchLeadEnrollments.fulfilled, (s, a) => {
      s.enrollmentsByLead[a.payload.leadId] = a.payload.enrollments || [];
    });
  },
});

export default slice.reducer;
